import React from 'react'
import Comp_Auto_Complete from '../components/comp_auto_complete';
export function Comp_Add_Site_Master(props){
    return(<div className="modal fade bd-example-modal-xl"  id="divAddSiteMaster" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xlll" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Customer Sites</h5>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        <form id="frmAddSiteMaster" name="frmAddSiteMaster">
       
        <div className="modal-body">
        <div className="row">
                  {/* <!-- left column --> */}
                  <div className="col-md-12">
                      <div className="card card-danger">
                              <input type="hidden" name="res_func" id="res_func" value={btoa("okResProCate")} />
                              <input type="hidden" name="curl_type" id="curl_type" value={btoa("addSiteMaster")} />
                              <input type="hidden" name="m_type" id="m_type" value={btoa("addSiteMaster")} />
                              <input type="hidden" name="log_id" id="log_id" value={props.logUser[0]["id"]}/>
                              <input type="hidden" name="log_app_id" id="log_app_id" value={props.logUser[0]["app_user_id"]}/>
                              <input type="hidden" name="type_id" id="type_id" value="2" />
                              
                              <div className="card-body">
                                <table>
                                    <tr>
                                        <td><label for="exampleInputEmail1">Party/Customer</label></td>
                                        <td> 
                                        <Comp_Auto_Complete  comp_id={"ser_party_name"} comp_name={"ser_party_name"} target_obj={"site_party_info_id"} autoList={[]} placeHolder={"Customer/Party"} propClass={"form-control form-control-sm"} />
               <input type="hidden" class="form-control" id="site_party_info_id" name="site_party_info_id"/>
                                        </td>
                                    </tr>
                                    
                                    <tr>
                                        <td><label for="exampleInputEmail1">Site Name*</label></td>
                                        <td> <input type="text" id="site_name" name="site_name" className="form-control required" placeholder="" /></td>
                                    </tr>
                                    <tr>
                                        <td><label for="exampleInputEmail1">Description(if Any)</label></td>
                                        <td> <input type="text" id="details" name="details" className="form-control required" placeholder="" /></td>
                                    </tr>
                                   
                                </table>
                                 
                                  <div className="col-md-6 respSSL"></div>
                                  <div id="testing2dd2222"></div>
                              </div>
                      </div>
                  </div>
              </div>
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">Close</button>
          <button type="button" className="btn _btnSetColor btn-primary">Save</button>
        </div>
        </form>
      </div>
      </div>
      </div>)
}

export default Comp_Add_Site_Master;